import { Link, NavLink } from "react-router-dom";
import { Phone, Menu, X } from "lucide-react";
import { useState } from "react";
import { useSettings } from "@/lib/hooks";
import Logo from "@/components/Logo";

const NAV = [
  { to: "/", label: "Accueil" },
  { to: "/services", label: "Services" },
  { to: "/tarifs", label: "Tarifs" },
  { to: "/zones", label: "Zones" },
  { to: "/avis", label: "Avis" },
  { to: "/contact", label: "Contact" },
];

export default function Header() {
  const settings = useSettings();
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-40 bg-white/95 backdrop-blur-md border-b border-surface-200" data-testid="site-header">
      <div className="max-w-6xl mx-auto px-4 lg:px-6 h-16 lg:h-[72px] flex items-center justify-between gap-4">
        <Link to="/" className="flex items-center" data-testid="logo-link" aria-label="Depann7 — Accueil">
          <Logo tone="dark" className="h-7 sm:h-9" />
        </Link>

        <nav className="hidden lg:flex items-center gap-1">
          {NAV.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              end={n.to === "/"}
              className={({ isActive }) =>
                `px-3 py-2 rounded-lg text-sm font-semibold transition-colors ${isActive ? "text-brand bg-brand-50" : "text-txt-700 hover:text-brand hover:bg-surface-50"}`
              }
              data-testid={`nav-${n.label.toLowerCase().replace(/\s+/g, "-")}`}
            >
              {n.label}
            </NavLink>
          ))}
        </nav>

        <a
          href={`tel:${settings?.company_phone_raw || ""}`}
          className="hidden md:flex items-center gap-2.5 bg-brand hover:bg-brand-600 text-white rounded-xl px-4 py-2.5 transition-colors"
          data-testid="header-call-link"
        >
          <Phone size={16} />
          <div className="leading-tight">
            <div className="font-bold text-sm">{settings?.company_phone || "07 53 95 58 90"}</div>
            <div className="text-[10px] text-brand-200 font-medium">24h/24 - 7j/7</div>
          </div>
        </a>

        <button
          className="lg:hidden text-txt-700 p-2 -mr-2"
          onClick={() => setOpen(true)}
          aria-label="Ouvrir le menu"
          data-testid="mobile-menu-open-btn"
        >
          <Menu size={24} />
        </button>
      </div>

      {open && (
        <div className="fixed inset-0 z-50 bg-white flex flex-col" data-testid="mobile-menu-panel">
          <div className="h-16 flex items-center justify-between px-4 border-b border-surface-200">
            <Link to="/" onClick={() => setOpen(false)} className="flex items-center">
              <Logo tone="dark" className="h-7" />
            </Link>
            <button onClick={() => setOpen(false)} className="text-txt-700 p-2" data-testid="mobile-menu-close-btn">
              <X size={24} />
            </button>
          </div>
          <nav className="flex-1 overflow-y-auto px-4 py-6 flex flex-col gap-1">
            {[
              { to: "/", label: "Accueil" },
              { to: "/demande", label: "Demande de dépannage" },
              { to: "/simulateur", label: "Simulateur de prix" },
              { to: "/services", label: "Services" },
              { to: "/zones", label: "Zones d'intervention" },
              { to: "/tarifs", label: "Tarifs" },
              { to: "/avis", label: "Avis clients" },
              { to: "/professionnels", label: "Professionnels" },
              { to: "/suivi", label: "Suivi de demande" },
              { to: "/contact", label: "Contact" },
              { to: "/a-propos", label: "À propos" },
            ].map((n) => (
              <NavLink
                key={n.to}
                to={n.to}
                onClick={() => setOpen(false)}
                className={({ isActive }) =>
                  `text-base font-semibold py-3 px-4 rounded-xl transition-colors ${isActive ? "text-brand bg-brand-50" : "text-txt-900 hover:bg-surface-50"}`
                }
              >
                {n.label}
              </NavLink>
            ))}
            <a
              href={`tel:${settings?.company_phone_raw || ""}`}
              className="mt-4 bg-brand text-white font-bold text-center rounded-xl py-4 flex items-center justify-center gap-2"
              data-testid="mobile-menu-call-btn"
            >
              <Phone size={18} />
              {settings?.company_phone || "07 53 95 58 90"}
            </a>
          </nav>
        </div>
      )}
    </header>
  );
}
